export function toSelectionPathSegment(assetId: string, dependencyPath: string): string {
  const separatorIndex = dependencyPath.lastIndexOf('/');
  const filename = separatorIndex === -1 ? dependencyPath : dependencyPath.slice(separatorIndex + 1);
  return `${assetId}:${filename.toLowerCase()}`;
}

export function isSameSelectionPath(left: string[] | undefined, right: string[] | undefined): boolean {
  if (!left || !right || left.length === 0 || left.length !== right.length) return false;
  return left.every((segment, index) => segment === right[index]);
}

export function isSelectionPathAncestor(candidate: string[], path: string[] | undefined): boolean {
  if (!path || candidate.length === 0 || candidate.length >= path.length) return false;
  return candidate.every((segment, index) => segment === path[index]);
}
